import { call, put } from 'redux-saga/effects';
import { request } from '../modules/client';
import { ActionTypes } from '../constants/index';
import { analytics } from '../modules/analytics';

export function* network(
  urlCategory: string,
  urlAction: string,

  successActionType: string = null, // actiontype to be called on logical success
  failActionType: string = null,    // actiontype to be called on logical failure

  payload: Object = {},

  trackEvent: Boolean = true,
  trackParams: Boolean = false,     // include the payload to tracking detail
) {

  if (trackEvent) {
    const params = trackParams ? payload : {};
    analytics.trackEvent(urlCategory, urlAction.split('/').join('_'), payload);
  }

  const urlPath = `api/${urlCategory}/${urlAction}`;
  try {
    const response = yield call(request, urlPath, { payload });

    yield put({ type: ActionTypes.NETWORK_SUCCESS, payload: {} });

    if (response.status === 'success') {
      // console.log('success');
      if (successActionType !== null) {
        yield put({
          type: successActionType,
          payload: response.result,
        });
      }
    }
    if (response.status === 'fail') {
      if (response.result.message === 'incompatible') {
        yield put({ type: ActionTypes.CLIENT_APP_UPDATE_REQUEST });
      }
      else if (response.result.message === 'authentication failure') {
        // console.log('logging out due to auth fail');
        yield put({ type: ActionTypes.SESSION_LOGOUT_REQUEST });
      }
      else if (failActionType !== null) {
        yield put({
          type: failActionType,
          payload: {
            message: response.result.message,
            data: response.result.data,
          },
        });
      }
    }
  }
  catch (error) {
    yield put({ type: ActionTypes.NETWORK_ERROR, payload: {} });
  }
}



// WEBPACK FOOTER //
// ./scripts/sagas/network.js